// import React, { useState } from "react";
// import Modal from "../modal/Modal";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addToCart,
//   decreaseCart,
//   incrementCart,
// } from "../../store/reducers/cartSlice";
// import { original } from "@reduxjs/toolkit";
// import toast from "react-hot-toast";
// import { Link } from "react-router-dom";
// function Card({ data }) {
//   let [isOpen, setIsOpen] = useState(false);
//   const dispatch = useDispatch();
//   const cart = useSelector((state) => state.cart);
//     const imgSrc = Array.isArray(data?.image) ? data.image[0] : data?.image;

//   function closeModal() {
//     setIsOpen(false);
//   }

//   function openModal() {
//     setIsOpen(true);
//   }

//   const handleAddToCart = (product) => {
//     dispatch(addToCart(product));
//   };
//   const Cart = cart.cartItems.find((cartItem) => cartItem._id === data._id);
//   return (
//     <>
//       {" "}
//     <Link to={"/product/" + data._id} style={{textDecoration:"none"}}>
//       <div className="group box-border overflow-hidden flex rounded-md shadow-sm pe-0 flex-col items-center bg-white relative">
//         <div
//           onClick={openModal}
//           className="relative flex justify-center w-full cursor-pointer"
//         >
//        {data.price > 0 && data.originalPrice > data.price && (
//   <span className="absolute text-dark text-xs bg-orange-500 text-white py-1 px-2 rounded font-medium z-10 right-4 top-4">
//     {Math.round(
//       ((data.originalPrice - data.price) / data.originalPrice) * 100
//     )}
//     % OFF
//   </span>
// )}

//           {data.quantity !== 0 ? (
//             ""
//           ) : (
//             <span className="absolute inline-flex items-center justify-center px-2 py-1 bg-red-100 text-red-600 border-0 rounded-full text-xs font-semibold z-10 left-4 top-4">
//               Stock Out
//             </span>
//           )}

//           <span
//             style={{
//               boxSizing: "borderBox",
//               display: "inline-block",
//               overflow: "hidden",
//               width: "initial",
//               height: "initial",
//               background: "none",
//               opacity: "1",
//               border: "0px",
//               margin: "0px",
//               padding: "0px",
//               position: "relative",
//               maxWidth: "100%",
//             }}
//           >
//             <span
//               style={{
//                 boxSizing: "border-box",
//                 display: "block",
//                 width: "initial",
//                 height: "initial",
//                 background: "none",
//                 opacity: "1",
//                 border: "0",
//                 margin: "0",
//                 padding: "0",
//                 maxWidth: "100%",
//               }}
//             >
//               <img
//                 style={{
//                   display: "block",
//                   maxWidth: "100%",
//                   width: "initial",
//                   height: "initial",
//                   background: "none",
//                   opacity: "1",
//                   border: "0",
//                   margin: "0",
//                   padding: "0",
//                 }}
//               />
//             </span>
         

// <img
//   src={imgSrc}
//   decoding="async"
//   data-nimg="intrinsic"
//   className="object-cover transition duration-150 ease-linear transform group-hover:scale-105"
//   crossOrigin={imgSrc?.includes("api.pufframa.com") ? "anonymous" : undefined}

//               style={{
//                 inset: "0px",
//                 boxSizing: " border-box",
//                 padding: "0px",
//                 border: "none",
//                 margin: "auto",
//                 display: " block",
//                 width: "160px",
//                 height: "160px",
//                 minWidth: "100%",
//                 maxWidth: "100%",
//                 minHeight: "100%",
//                 maxHeight: " 100%",
//               }}
//             />
//           </span>
//         </div>
//         <div className="w-full px-3 lg:px-4 pb-4 overflow-hidden">
//           <div className="relative mb-1">
//             <span className="text-orange-600 font-medium text-xs d-block mb-1">
//               By {data?.author?.name || data?.author?.firstName || "Admin"}
//             </span>
//             <h2 className="text-heading truncate mb-0 block text-sm font-medium text-gray-600">
//               <span className="line-clamp-2">{data.title}</span>
//             </h2>
//           </div>
//           <div className="flex justify-between items-center text-heading text-sm sm:text-base space-s-2 md:text-base lg:text-xl">
//             <div className="product font-bold">
//               {data.price === 0 ? (
//                 // ✅ Show only original price if price is 0
//                 <span className="inline-block text-lg font-semibold text-gray-800">
//                   ${data.originalPrice}
//                 </span>
//               ) : (
//                 <>
//                   <span className="inline-block text-lg font-semibold text-gray-800">
//                     ${data.price}
//                   </span>
//                   {data.price !== data.originalPrice && (
//                     <del className="sm:text-sm font-normal text-base text-gray-400 ml-1">
//                       ${data.originalPrice}
//                     </del>
//                   )}
//                 </>
//               )}
//             </div>

//             {/* {Cart ? (
//               <div>
//                 <div className="h-9 w-auto flex flex-wrap items-center justify-evenly py-1 px-2 bg-emerald-500 text-white rounded">
//                   <button onClick={() => dispatch(decreaseCart(data))}>
//                     <span className="text-dark text-base">
//                       <svg
//                         stroke="currentColor"
//                         fill="currentColor"
//                         strokeWidth="0"
//                         viewBox="0 0 512 512"
//                         height="1em"
//                         width="1em"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="32"
//                           d="M400 256H112"
//                         ></path>
//                       </svg>
//                     </span>
//                   </button>
//                   <p className="text-sm text-dark px-1 font-semibold">
//                     {Cart.cartQuantity}
//                   </p>
//                   <button onClick={() => dispatch(incrementCart(data))}>
//                     <span className="text-dark text-base">
//                       <svg
//                         stroke="currentColor"
//                         fill="currentColor"
//                         strokeWidth="0"
//                         viewBox="0 0 512 512"
//                         height="1em"
//                         width="1em"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="32"
//                           d="M256 112v288m144-144H112"
//                         ></path>
//                       </svg>
//                     </span>
//                   </button>
//                 </div>
//               </div>
//             ) : (
//               <button
//                 // disabled={data.quantity === 0 ? true : false}
//                 onClick={() =>
//                   data.quantity !== 0
//                     ? handleAddToCart(data)
//                     : toast.error("No stock available")
//                 }
//                 ariallabel="chart"
//                 className={
//                   data.quantity === 0
//                     ? "!cursor-default h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-emerald-500 hover:border-emerald-500 hover:bg-emerald-500 hover:text-white transition-all"
//                     : "!cursor-pointer h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-emerald-500 hover:border-emerald-500 hover:bg-emerald-500 hover:text-white transition-all"
//                 }
//               >
//                 <span className="text-xl">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
//                     />
//                   </svg>
//                 </span>
//               </button>
//             )} */}
//           </div>
//         </div>
//       </div>
//       </Link>
//       <Modal data={data} isOpen={isOpen} closeModal={closeModal} />
//     </>
//   );
// }

// export default Card;

















import React, { useState } from "react";
import Modal from "../modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store/reducers/cartSlice";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { FiHeart, FiShoppingCart } from "react-icons/fi";

function Card({ data }) {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const imgSrc = Array.isArray(data?.image)
    ? data.image[0]
    : data?.image;

  const productUrl = `/product/${data?._id}`;

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const handleAddToCart = () => {
    if (data?.quantity === 0) {
      toast.error("No stock available");
      return;
    }

    dispatch(addToCart(data));
  };

  const Cart = cart.cartItems.find(
    (cartItem) => cartItem._id === data?._id
  );

  const discount =
    data?.originalPrice > 0 &&
    data?.price > 0 &&
    data.originalPrice > data.price
      ? Math.round(
          ((data.originalPrice - data.price) /
            data.originalPrice) *
            100
        )
      : 0;

  return (
    <>
      <div className="group relative flex h-full min-w-0 flex-col overflow-hidden rounded-[7px] border border-[#f0edf0] bg-white transition-shadow duration-200 hover:shadow-md">

        {/* Product Image and Badges */}
        <div className="relative flex h-[108px] items-center justify-center overflow-hidden bg-white px-2 pt-2 sm:h-[122px] lg:h-[130px]">

          {/* Clickable Product Image */}
          <Link
            to={productUrl}
            aria-label={`View ${data?.title || "product"}`}
            className="absolute inset-0 z-[1] flex cursor-pointer items-center justify-center px-2 pt-2"
          >
            {imgSrc ? (
              <img
                src={imgSrc}
                alt={data?.title || "Product"}
                loading="lazy"
                decoding="async"
                crossOrigin={
                  imgSrc?.includes("api.pufframa.com")
                    ? "anonymous"
                    : undefined
                }
                className="h-full w-full object-contain transition-transform duration-200 ease-out group-hover:scale-[1.04]"
              />
            ) : (
              <span className="text-xs text-gray-400">
                No image available
              </span>
            )}
          </Link>

          {/* Discount Badge */}
          {discount > 0 && (
            <span className="pointer-events-none absolute right-[6px] top-[6px] z-[2] rounded-[4px] bg-[#ff5b69] px-[6px] py-[3px] text-[8px] font-semibold leading-none text-white">
              {discount}% OFF
            </span>
          )}

          {/* Stock Badge */}
          {data?.quantity === 0 && (
            <span className="pointer-events-none absolute left-[5px] top-[6px] z-[2] rounded-[4px] bg-red-100 px-[5px] py-[3px] text-[8px] font-semibold leading-none text-red-600">
              Stock Out
            </span>
          )}

          {/* Wishlist / Quick View */}
          {/* <button
            type="button"
            aria-label="Quick view product"
            onClick={openModal}
            className="absolute right-[6px] top-[6px] z-[3] hidden h-[24px] w-[24px] items-center justify-center rounded-full bg-white/95 text-[#99929f] shadow-sm transition-colors hover:text-[#7027df] sm:flex"
          >
            <FiHeart size={13} />
          </button> */}
        </div>

        {/* Product Details */}
        <div className="flex flex-1 flex-col px-[7px] pb-[8px] pt-[3px] sm:px-[9px]">

          {/* Author and Product Title */}
          <div className="mb-[5px] min-w-0">
            <p className="mb-[3px] truncate text-[8px] font-medium leading-[10px] text-[#a06b22]">
              By{" "}
              {data?.author?.name ||
                data?.author?.firstName ||
                "Admin"}
            </p>

            <Link
              to={productUrl}
              className="block min-h-[29px] text-[10px] font-medium leading-[14px] text-[#28232c] no-underline hover:text-[#7027df] sm:text-[11px] sm:leading-[14px]"
            >
              <span className="line-clamp-2">
                {data?.title || "Untitled Product"}
              </span>
            </Link>
          </div>

          {/* Price */}
          <div className="mb-[7px] flex min-h-[17px] flex-wrap items-baseline gap-x-[5px] gap-y-[1px]">
            {data?.price === 0 ? (
              <span className="text-[12px] font-bold leading-[16px] text-[#25212a]">
                ${data?.originalPrice}
              </span>
            ) : (
              <>
                <span className="text-[12px] font-bold leading-[16px] text-[#25212a]">
                  ${data?.price}
                </span>

                {data?.originalPrice != null &&
                  data.price !== data.originalPrice && (
                    <del className="text-[9px] font-normal leading-[12px] text-[#a39da7]">
                      ${data.originalPrice}
                    </del>
                  )}
              </>
            )}
          </div>

          {/* Add to Cart */}
          <button
            type="button"
            disabled={data?.quantity === 0}
            onClick={handleAddToCart}
            aria-label="Add to cart"
            className={`mt-auto flex h-[25px] w-full items-center justify-center gap-[5px] rounded-[5px] px-2 text-[9px] font-semibold text-white transition-colors duration-200 ${
              data?.quantity === 0
                ? "cursor-not-allowed bg-gray-400"
                : "cursor-pointer bg-[#6927d9] hover:bg-[#511caf]"
            }`}
          >
            <FiShoppingCart size={11} strokeWidth={2} />
            Add to cart
          </button>
        </div>
      </div>

      {/* Product Quick View Modal */}
      <Modal
        data={data}
        isOpen={isOpen}
        closeModal={closeModal}
      />
    </>
  );
}

export default Card;